export const getContactItemById = ({ contacts, usersManagement }, itemId) => {
  const contact = contacts?.contactsById?.[itemId];
  if (contact) {
    return contact;
  }

  const user = usersManagement?.list?.find(item => item.id === itemId);
  if (user) {
    return { ...user, isUser: true, firstName: user.firstName || user.email };
  }

  return null;
};

export const getContacts = ({ contacts, usersManagement }) => {
  const contactList = Object.values(contacts?.contactsById ?? []);
  const userWithIsUserFlag =
    usersManagement?.list?.map(user => ({
      ...user,
      isUser: true,
      firstName: user.firstName || user.email,
    })) ?? [];

  return [...contactList, ...userWithIsUserFlag].sort(
    (a, b) => a.firstName?.localeCompare(b.firstName) || a.lastName?.localeCompare(b.lastName),
  );
};
